import { render, staticRenderFns } from "./ShippingCostTableAdmin.vue?vue&type=template&id=222f1980&scoped=true"
import script from "./ShippingCostTableAdmin.vue?vue&type=script&lang=js"
export * from "./ShippingCostTableAdmin.vue?vue&type=script&lang=js"
import style0 from "./ShippingCostTableAdmin.vue?vue&type=style&index=0&id=222f1980&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222f1980",
  null
  
)

export default component.exports